// https://github.com/streamich/react-use/blob/master/docs/createReducerContext.md
import createReducerContext from "react-use/lib/factory/createReducerContext";

const initialReducerState = {
    singlePropertyForm: {
       inputs: {
        unitname: "",
        unitaddress: "",
        description: "",
        leasetype: "",
        useclass: "",
        size: "",
        rent: "",
        photos: "",
        contactdetails: "",
       }

    }
};

const reducer = (state, action) => {
    switch (action.type) {
        case "singlePropertyFormInput":
            return {
              ...state,
              singlePropertyForm: {
                ...state.singlePropertyForm,
                inputs: {
                  ...state.singlePropertyForm.inputs,
                  ...action.payload,
                },
              },
            };
        default:
        throw new Error('eeror');
  }
};





const [useReducer, ReducerProvider] = createReducerContext(reducer, initialReducerState);

export { ReducerProvider, initialReducerState };

export default useReducer;
